import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { pages } from '../../nav-items';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { NotificationService } from 'ui-components/services/notification-service';
import messages from '../messages';

export const PRINT_SETTINGS_PATH = `/${pages.settings.location}/${pages.printing.location}`;

export const PrinterIsUnavailable = ({ notificationId, selectedPrinterName = '', workstationId }) => {
  const history = useHistory();

  const workstation = useSelector((state) => Global.selectConnectWorkstationById(state, { workstationId }));

  const navigateToPrintSettings = useCallback(() => {
    history.push(PRINT_SETTINGS_PATH);
    NotificationService.removeNotification(notificationId);
  }, [history, notificationId]);

  return (
    <>
      <Text
        formattedMessageValues={{
          workstationName: workstation?.description ?? '',
          selectedPrinterName,
        }}
        textType={TextType.Paragraph}
        value={messages.connectOfflineError}
      />
      <FlexRow>
        <Button onClick={navigateToPrintSettings} theme='link'>
          <FormattedMessage {...messages.navigateToPrintSettings} />
        </Button>
      </FlexRow>
    </>
  );
};

PrinterIsUnavailable.propTypes = {
  notificationId: PropTypes.string.isRequired,
  selectedPrinterName: PropTypes.string,
  workstationId: PropTypes.string.isRequired,
};
